import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { MatchResult } from './match-result';
export { MatchResult };
import { matchResultSchema } from '@schemas/business-objects/match-result';
import { MatchFormGroup } from './match-form-group';

export class MatchResultFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    age: SchemaFormControl;
    binUnder3: SchemaFormControl;
    bin3To4: SchemaFormControl;
    bin4To5: SchemaFormControl;
    bin5To6: SchemaFormControl;
    bin6To7: SchemaFormControl;
    bin7To8: SchemaFormControl;
    bin8Plus: SchemaFormControl;
    averageBme: SchemaFormControl;
    standardDeviation: SchemaFormControl;
    mlfScore: SchemaFormControl;
    phenotype: SchemaFormControl;
    ringOneUnder3: SchemaFormControl;
    ringOne3To4: SchemaFormControl;
    ringOne4To5: SchemaFormControl;
    ringOne5To6: SchemaFormControl;
    ringOne6To7: SchemaFormControl;
    ringOne7To8: SchemaFormControl;
    ringOne8Plus: SchemaFormControl;
    ringTwoUnder3: SchemaFormControl;
    ringTwo3To4: SchemaFormControl;
    ringTwo4To5: SchemaFormControl;
    ringTwo5To6: SchemaFormControl;
    ringTwo6To7: SchemaFormControl;
    ringTwo7To8: SchemaFormControl;
    ringTwo8Plus: SchemaFormControl;
    ringThreeUnder3: SchemaFormControl;
    ringThree3To4: SchemaFormControl;
    ringThree4To5: SchemaFormControl;
    ringThree5To6: SchemaFormControl;
    ringThree6To7: SchemaFormControl;
    ringThree7To8: SchemaFormControl;
    ringThree8Plus: SchemaFormControl;
    legacyId: SchemaFormControl;
    matchId: SchemaFormControl;
    match: MatchFormGroup;
  };

  declare value: Partial<MatchResult>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(matchResultSchema, MatchResult, data, options);
  }

  get object(): MatchResult {
    return new MatchResult(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'match':
        return new MatchFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<MatchResult[]> {
    return MatchResult.find(filter);
  }

  static async findOne(filter?: any): Promise<MatchResult | null> {
    return MatchResult.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<MatchResult> {
    return MatchResult.findById(id, filter);
  }

  static async create(data: Partial<MatchResult>): Promise<MatchResult> {
    return MatchResult.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<MatchResult>,
  ): Promise<MatchResult> {
    return MatchResult.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return MatchResult.deleteById(id);
  }
}

export class MatchResultFormArray extends PersistedFormArray {
  declare controls: MatchResultFormGroup[];

  readonly entityName = 'MatchResult' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(matchResultSchema, MatchResult, options);
  }

  protected override createItemGroup() {
    return new MatchResultFormGroup();
  }

  get array(): MatchResult[] {
    return this.controls.map((group: MatchResultFormGroup) => group.object);
  }
}

export class MatchResultPersistedArray extends PersistedArray<MatchResult> {
  readonly entityName = 'MatchResult' as const;

  constructor(options?: PersistedArrayOptions) {
    super(MatchResult, options);
  }
}
